import { ApiError } from './api/client';

/** Best-effort human message from any thrown value. */
export function errorMessage(error: unknown, fallback = 'Something went wrong.'): string {
  if (error instanceof ApiError) return error.message;
  if (error instanceof Error) return error.message;
  return fallback;
}

/** Whole-rupee LKR amount, e.g. `formatLkr(36_000)` → "LKR 36,000". Prices
 * are stored/sent as integer whole rupees (docs/packages.md), never floats. */
export function formatLkr(amountLkr: number): string {
  return `LKR ${amountLkr.toLocaleString('en-LK')}`;
}
